import React, { useState, useEffect, useRef } from 'react';
import './timer.css';
export function Timer(props) {
    var _a = useState(Number(props.seconds)), time = _a[0], setTime = _a[1];
    var _b = useState(false), over = _b[0], setOver = _b[1];
    var countRef = useRef(over);
    countRef.current = over;
    var tick = function () {
        if (time === 1) {
            setOver(true);
            props.endFunc();
        }
        else {
            setTime(time - 1);
        }
    };
    useEffect(function () {
        var countdown = setInterval(function () { return tick(); }, 1000);
        return function () { return clearInterval(countdown); };
    });
    useEffect(function () {
        setTime(Number(props.seconds));
        setOver(false);
    }, [props.reset, props.seconds]);
    function timing(time, over) {
        if (over || props.reset)
            return null;
        else if (time < 10)
            return "0".concat(time);
        else
            return time;
    }
    return (React.createElement("div", null,
        React.createElement("p", { className: "timer" }, timing(time, over))));
}
